import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Typography } from '@mui/material';
import TSButton from 'components/common/Button/Button';

import { ROUTES } from 'constants/RoutePaths';
import { buildRoutePath } from 'utils/utility';
import { setQRCodeId } from 'app/state';

import { useGetTrailListByQRCodeQuery } from 'app/api/trailApiSlice';

const TrailsByQRCode = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // The QR Code's permanent code from the sign's URL, e.g. CMT-DL7R.
  const { qrCode } = useParams();

  useEffect(() => {
    dispatch(setQRCodeId(qrCode));
  }, [dispatch, qrCode]);

  const {
    data: trail,
    isLoading: isTrailLoading,
    error,
  } = useGetTrailListByQRCodeQuery(qrCode);

  useEffect(() => {
    if (trail?.length === 1) {
      navigate(
        `/${buildRoutePath(ROUTES.TRAIL_DETAIL, {
          trailId: trail[0].trailid,
        })}`
      );
    }
  }, [trail]);

  if (isTrailLoading) {
    return <div>Loading...</div>;
  }

  if (error?.status === 404) {
    return (
      <div className="px-4 py-2">
        <Typography className="py-2" variant="h2">
          QR Code not found
        </Typography>
        <Typography className="py-2" variant="body1">
          We couldn't find a QR Code with the code {qrCode}. Check the code on
          the sign, or browse all trails instead.
        </Typography>
        <div className="flex flex-col gap-2 max-w-md">
          <TSButton
            btnText="Browse all trails"
            variant="contained"
            onClickFunc={() => navigate(`/${ROUTES.TRAIL_HOME}`)}
          />
        </div>
      </div>
    );
  }

  if (error) {
    return <div className="px-4 py-2">Error loading trails.</div>;
  }

  return (
    <>
      <div className="px-4 py-2">
        <Typography className="py-2" variant="body1">
          {trail?.length > 0
            ? 'Which trail do you plan to walk today?'
            : "This QR Code doesn't list any trails."}
        </Typography>

        <div className="flex flex-col gap-2 max-w-md">
          {trail?.length > 0 &&
            trail?.map((trail) => (
              <TSButton
                key={trail.trailid}
                btnText={trail.trailname}
                variant="contained"
                onClickFunc={() =>
                  navigate(
                    `/${buildRoutePath(ROUTES.TRAIL_DETAIL, {
                      trailId: trail.trailid,
                    })}`
                  )
                }
              />
            ))}
        </div>
      </div>
    </>
  );
};

export default TrailsByQRCode;
